<app-toast></app-toast>
<app-delete-confirmation-dialog title="{{ 'shared.delete' | transloco }}?"
    body="{{ 'admin.are_you_sure_delete_item' | transloco }}"></app-delete-confirmation-dialog>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full max-w-ultrawide">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full max-w-ultrawide">
        <app-admin-navigation [isActiveNumber]="9"></app-admin-navigation>
    </div>

    <div class="flex w-full max-w-ultrawide mobile:flex-col desktop:justify-between items-center">
        <div class="flex flex-col gap-2">
            <!-- Header -->
            <div class="flex gap-2 w-full mt-4 max-w-ultrawide">
                <img src="assets/icons/admin/box-error.svg" class="w-[24px] h-[24px]"
                    alt="{{ 'shared.icon' | transloco }}">
                <h1 class="font-bold text-xl">
                    {{ 'admin.products_services' | transloco }}</h1>
            </div>
            <p class="text-neutral-500 self-start mt-2"> {{ 'admin.products_services_desc' | transloco }}</p>
        </div>

        <div class="w-[250px] h-[50px]">
            <app-custom-button buttonText="{{ 'admin.products_services_add' | transloco }}"
                leadingIcon="assets/icons/add.svg" backgroundColor="bg-success" textColor="text-white"
                borderColor="border-success" hoverBorderColor="hover:border-success-600"
                hoverBackgroundColor="hover:bg-success-600" (buttonClick)="createItem()"></app-custom-button>
        </div>
    </div>

    <!-- Content -->
    <div class="w-full max-w-ultrawide mt-4" #editCreateRef>

        <!-- Edit/Create-->
        <app-create-edit-product [(isOpen)]="isEditCreateOpen" [isEditing]="isEditing" [product]="selectedProduct"
            [toast]="toast" [reloadCallbackFunction]="reloadProducts"></app-create-edit-product>

        <!-- Card -->
        <div class="relative w-full rounded-xl border border-border shadow-md" *ngFor="let product of products">
            <!-- Top actions (edit/delete) -->
            <div class="absolute right-3 top-3 flex items-center gap-3 text-neutral-400">
                <!-- Edit -->
                <button title="{{ 'settings.button.edit' | transloco }}" class="p-1 rounded hover:bg-secondary-200"
                    (click)="editItem(product)">
                    <img src="assets/icons/edit.svg" alt="{{ 'settings.button.edit' | transloco }}" class="w-6 h-6" />
                </button>
                <!-- Delete -->
                <button title="{{ 'shared.delete' | transloco }}" (click)="deleteItem(product)">
                    <svg width="24" height="24" viewBox="0 0 50 50">
                        <circle cx="25" cy="25" r="24" fill="#FF0000" />
                        <image href="assets/icons/delete.svg" x="12" y="12" height="25px" width="25px" />
                    </svg>
                </button>
            </div>

            <!-- Body -->
            <div class="p-6">
                <p class="font-bold text-lg">{{ product.name }}</p>

                <div class="mt-2 text-sm text-neutral-500">
                    <span class="inline-block font-medium text-neutral-500">{{ product.type }}</span>
                </div>

                <p class="mt-4 text-neutral-700">
                    {{ product.description }}
                </p>

                <!-- Target segments -->
                <div class="mt-6">
                    <p class="text-sm text-neutral-500 mb-2">{{ 'admin.target_segments' | transloco }}:</p>
                    <div class="flex flex-wrap gap-2">
                        <span
                            class="inline-flex items-center rounded-md border border-border bg-neutral-100 px-3 py-1 text-sm"
                            *ngFor="let segment of product.target_segments">
                            {{ segment }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>